<section>
    <div class="btn-actions">
        <button mat-raised-button color="primary"
        (click)="openAssignPermissions()">
            <mat-icon>add</mat-icon>
            Agregar
        </button>
        <button [disabled]="permissionSelection.selected.length <= 0"
        (click)="clickRevokePermissions()"
         mat-raised-button color="warn">
            <mat-icon>remove</mat-icon>
            Quitar
        </button>
    </div>
    <table class="w-50" mat-table 
        [dataSource]="dataSource">
        <ng-container matColumnDef="selection">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? toggleAllPermissions(): null"
                [checked]="permissionSelection.hasValue() && isAllPermissionsSelected()"
                [indeterminate]="permissionSelection.hasValue() && !isAllPermissionsSelected()">
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let element">
                <mat-checkbox (click)="$event.stopPropagation()"
                (change)="$event ? permissionSelection.toggle(element) : null"
                [checked]="permissionSelection.isSelected(element)">
                </mat-checkbox>
            </td>
        </ng-container>
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>
                Permisos
            </th>
            <td mat-cell *matCellDef="let element">
                <h6>{{ element.description}}</h6>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
    </table>
</section>